import { render, staticRenderFns } from "./PlacementProvider.vue?vue&type=template&id=0304ad34"
import script from "./PlacementProvider.vue?vue&type=script&lang=js"
export * from "./PlacementProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports